import { i18n } from '@/plugins/i18n'

function checkToken(token) {
  if (!token) return false
  if (i18n.te(token, i18n.locale)) return true
  if (i18n.fallbackLocale && i18n.te(token, i18n.fallbackLocale)) return true
  return false
}

/**
 * Returns the i18n token for a condition slug.
 * Checks disease.<slug>.title, then assessment.<slug>.title
 * @param {string} slug  e.g. 'malaria', 'depression'
 * @returns {string|null}
 */
export function conditionToken(slug) {
  if (!slug) return null

  const disease = `disease.${slug}.title`
  if (checkToken(disease)) return disease

  const assessment = `assessment.${slug}.title`
  if (checkToken(assessment)) return assessment

  return null
}

/**
 * Returns the i18n token for a disease category slug.
 * @param {string} slug  e.g. 'infectious_parasitic'
 * @returns {string|null}
 */
export function diseaseCategoryToken(slug) {
  if (!slug) return null

  const category = `condition_category.${slug}.title`
  if (checkToken(category)) return category

  return null
}